<template>
  <svg :width="width" :height="height" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.41667 7.33333H0.916667C0.40975 7.33333 0 6.92267 0 6.41667V0.916667C0 0.410667 0.40975 0 0.916667 0H6.41667C6.92358 0 7.33333 0.410667 7.33333 0.916667V6.41667C7.33333 6.92267 6.92358 7.33333 6.41667 7.33333ZM5.50004 1.83333H1.83337V5.5H5.50004V1.83333ZM10.0833 0H15.5833C16.0902 0 16.5 0.410667 16.5 0.916667V6.41667C16.5 6.92267 16.0902 7.33333 15.5833 7.33333H10.0833C9.57638 7.33333 9.16663 6.92267 9.16663 6.41667V0.916667C9.16663 0.410667 9.57638 0 10.0833 0ZM11 5.5H14.6667V1.83333H11V5.5ZM7.33333 15.5833C7.33333 16.0903 6.92358 16.5 6.41667 16.5H0.916667C0.40975 16.5 0 16.0903 0 15.5833V10.0833C0 9.57642 0.40975 9.16667 0.916667 9.16667H6.41667C6.92358 9.16667 7.33333 9.57642 7.33333 10.0833V15.5833ZM5.50004 11H1.83337V14.6667H5.50004V11ZM16.3333 15.5837C16.3333 16.0906 15.9236 16.5003 15.4167 16.5003H9.91667C9.40975 16.5003 9 16.0906 9 15.5837V10.0837C9 9.57674 9.40975 9.16699 9.91667 9.16699H15.4167C15.9236 9.16699 16.3333 9.57674 16.3333 10.0837V15.5837ZM14.5 11.0003H10.8334V14.667H14.5V11.0003Z" :fill="computedColor"/>
  </svg>

</template>
<script setup>
import {useTheme} from "@/stores/ThemeStore";
import {storeToRefs} from "pinia";
import {computed} from "vue";

const {color: themeColor} = storeToRefs(useTheme());

const props = defineProps({
    color: {
        type: String,
        required: false
    },
    width: {
      type: Number,
      default: 17
    },
    height: {
        type: Number,
        default: 17
    }
});

const computedColor = computed(() => props.color ?? themeColor.value.hex);

</script>
